import { StockLink, StockPrice } from "fin-web-components";
import type { StockNotesTabProps } from "fin-web-components";
import type { StockLinkDetailState } from "../../components/fin-web/useStockLinkDetail";
import { stockLinkDetailPropsForCode } from "../../components/fin-web/useStockLinkDetail";
import type { IntelligenceStockPick } from "./IntelligenceFeedType";
import { INTEL_DETAIL_PANEL_STYLE } from "./Config";
import { IntelStockAssessScores } from "./IntelStockAssessScores";

const STOCK_QUOTE_STYLE = INTEL_DETAIL_PANEL_STYLE.stockCard.quote;

function parsePriceText(v: string | undefined): number | null {
  if (!v?.trim() || v.trim() === "—") {
    return null;
  }
  const n = Number.parseFloat(v.replace(/,/g, ""));
  return Number.isFinite(n) ? n : null;
}

function parsePctText(v: string | undefined): number | null {
  if (!v?.trim() || v.trim() === "—") {
    return null;
  }
  const n = Number.parseFloat(v.trim().replace(/%$/, ""));
  return Number.isFinite(n) ? n : null;
}

export function IntelStockPickCard({
  pick,
  stockLinkDetail,
  requestStockDetailForLink,
  stockNotesTab,
}: {
  pick: IntelligenceStockPick;
  stockLinkDetail: StockLinkDetailState;
  requestStockDetailForLink: (stockCode: string) => void;
  stockNotesTab: StockNotesTabProps | null;
}) {
  const code = pick.code.trim();
  const priceNum = parsePriceText(pick.lastPrice);
  const pctNum = parsePctText(pick.changePct);

  return (
    <div className="lf-intel-stock-card">
      <div className="lf-intel-stock-head">
        <StockLink
          stockCode={code}
          stockName={pick.name}
          stockDetail={stockLinkDetail.code === code ? stockLinkDetail.data : null}
          detailLoading={stockLinkDetail.code === code && stockLinkDetail.loading}
          {...stockLinkDetailPropsForCode(stockLinkDetail, code)}
          onRequestDetail={requestStockDetailForLink}
          stockNotesTab={stockNotesTab}
        />
        <span className="lf-intel-stock-quote">
          {priceNum != null ? (
            <StockPrice
              mode="one-line"
              price={priceNum}
              change={pctNum ?? 0}
              fontSize={STOCK_QUOTE_STYLE.fontSize}
            />
          ) : (
            <span className="lf-intel-stock-quote-fallback">{pick.lastPrice || "—"}</span>
          )}
        </span>
      </div>
      <div className="lf-intel-stock-reason">{pick.recommendReason}</div>
      <IntelStockAssessScores
        fundamentalScore={pick.fundamentalScore}
        positionScore={pick.positionScore}
      />
    </div>
  );
}
